import { memo } from "react";

import { SECONDARY_COLOR } from "@hl/base-components/lib/theme/button";
import { Box, Button, Group, Menu, Text } from "@mantine/core";
import { IconCheck, IconChevronDown } from "@tabler/icons";

export type Props = {
  requiredAll: boolean;
  setRequiredAny: () => void;
  setRequiredAll: () => void;
};

const AllAnyMenu = ({ requiredAll, setRequiredAny, setRequiredAll }: Props) => {
  return (
    <Menu position="bottom-end">
      <Menu.Target>
        <Button
          size={"sm"}
          p="0px 4px 0px 8px"
          color={SECONDARY_COLOR}
          h={24}
          rightIcon={<IconChevronDown size={16} />}
        >
          <Text size="sm" w={25}>
            {requiredAll ? "all" : "any"}
          </Text>
        </Button>
      </Menu.Target>

      <Menu.Dropdown>
        <Menu.Item onClick={setRequiredAny}>
          <Group spacing={10}>
            <Box w={48}>any</Box>
            {!requiredAll && <IconCheck size={16} />}
          </Group>
        </Menu.Item>
        <Menu.Item onClick={setRequiredAll}>
          <Group spacing={10}>
            <Box w={48}>all</Box>
            {requiredAll && <IconCheck size={16} />}
          </Group>
        </Menu.Item>
      </Menu.Dropdown>
    </Menu>
  );
};

export default memo(AllAnyMenu);
